import React from 'react';
import { useParams } from 'react-router';
import { Button, message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import ProposalRevisionDetail from './ProposalRevisionDetail';
import {
  CANCEL_PROPOSAL_REVISION,
  GET_PROPOSAL_REVISION,
  APPROVE_PROPOSAL_REVISION,
} from 'gql/proposalRevisions';
import { useHasScopeTypeInProject, useProjectFrozen } from 'hooks';
import ApprovalSection from '../../../../layout/ApprovalSection';
import { PageContainer } from '@ant-design/pro-layout';

const { confirm } = Modal;

const showConfirm = ({ onOk }) => {
  confirm({
    title: 'Confirm to Cancel?',
    icon: <ExclamationCircleOutlined />,
    content: 'Status of cancelled application will be changed to DRAFT',
    onOk,
  });
};

const PendingProposalRevision = ({ reducer: { dispatch } }) => {
  const { id, projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { hasScopeType } = useHasScopeTypeInProject('WRITE_PROPOSAL_REVISION');
  const { data, loading } = useQuery(GET_PROPOSAL_REVISION, {
    variables: {
      ids: [id],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });
  const [cancelProposalRevision] = useMutation(CANCEL_PROPOSAL_REVISION, {
    refetchQueries: [
      {
        query: GET_PROPOSAL_REVISION,
        variables: {
          ids: [id],
          status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
        },
      },
    ],
    awaitRefetchQueries: true,
    onCompleted: () => {
      message.success('Application withdrawed successfully');
      dispatch({ type: 'SUBMIT' });
    },
  });
  const onOk = async () => {
    await cancelProposalRevision({
      variables: {
        input: {
          id,
          projectId,
        },
      },
    });
  };
  const refetchQueries = [
    {
      query: GET_PROPOSAL_REVISION,
      variables: {
        ids: [id],
        status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
      },
    },
  ];

  return (
    <PageContainer loading={loading}>
      {hasScopeType && !projectFrozen ? (
        <p>
          <Button
            type="primary"
            onClick={() => {
              showConfirm({ onOk });
            }}
          >
            Cancel Application
          </Button>
        </p>
      ) : (
        ''
      )}
      <ProposalRevisionDetail
        data={data}
        title="Proposal Revision Detail"
        confirm={false}
      />
      <ApprovalSection
        approvalRoute={data?.proposalRevisions[0].approvalRoute}
        refetchQueries={refetchQueries}
        mutation={APPROVE_PROPOSAL_REVISION}
        applicationType="PROPOSAL_REVISION"
      />
    </PageContainer>
  );
};

export default PendingProposalRevision;
